// Interface
export interface ConfigItem {
    day: number,
    refund_rate: number,
    turnover_times: number,
    activeStatus: number,
    createTime: number
}
export interface DailyRewardData {
    createTime: string;
    day: number;
    status: number;
    dayOne: number;
    dayTwo: number;
    dayThree: number;
    dayFour: number;
    dayFive: number;
    daySix: number;
    daySeven: number;
    availableAmount: number;
    givenAmount: number;
    rewards: FutureRewards[];
}
export interface FutureRewards {
    amount: string,
    date: string
}

export interface LossReliefData{
    activityIntro : any[]
    lossConfig : ConfigItem[]
    historyList : DailyRewardData[]
    weeklyRewardList : DailyRewardData[]
    futureRewards : FutureRewards[]
    todayBetDetails : DailyRewardData
    total : number
    pageNum : number
    pageSize : number
    cashbackTotal : number
    dayCount : number
    bannerIcon : string
}
// Constant

export const PAGE_SIZE = 20